import defaultTheme from './default';
import minimalTheme from './minimal';

const themes = {
  default: defaultTheme,
  minimal: minimalTheme,
};

export const getTheme = (themeName) => themes[themeName] || themes.default;
export const getAvailableThemes = () => Object.keys(themes);
